const avatarSizes = {
    tiny: 24,
    dropdown: 28,
    medium: 40,
    default: 64,
};

export { avatarSizes };
